<template lang="html">
  <job-offline-notice v-if="isJobOffline" />
  <div v-else class="fsd-job-detail" :style="jobTemplateStyle.vars">
    <div :class="jobTemplateStyle.cssClass" />
    <div ref="anchor" class="fsd-job-detail__anchor" />
    <div
      v-if="job && !jobLoadingId"
      ref="jobOutlet"
      class="fsd-job-detail__content"
    >
      <job-expired-notice v-if="isJobExpired" />
      <job-meta
        :job="job"
        :is-preview="isPreview"
        :class="{ 'card--expired': isJobExpired }"
      />

      <div
        v-tracking-context="{ content_element: 'ad' }"
        :class="{ 'card--expired': isJobExpired }"
      >
        <job-body :job="job" />
      </div>
    </div>
    <div
      v-if="jobLoadingId || resultsLoading"
      v-tracking-context="{ content_element: 'ad' }"
      class="fsd-job-detail__skeleton"
    >
      <div
        class="post__item post__item--meta-compact post__item--skeleton card"
      >
        <div class="columns post__item-headline" />
        <div class="post__item-meta media">
          <div class="media__body">
            <span class="columns post__item-date-begin post__item-published">
              <img :src="calendarSvgPath" class="post__item-icon" alt="" />
              <span
                class="post__item-date-begin post__item-date-begin--label"
              />
            </span>
            <span class="columns post__item-date-begin post__item-published">
              <img :src="finishFlagSvgPath" class="post__item-icon" alt="" />
              <span
                class="post__item-valid_through post__item-valid_through--label"
              />
            </span>
            <span
              class="columns post__item-employment-type post__item-published"
            >
              <img :src="workingHoursSvgPath" class="post__item-icon" alt="" />
              <span
                class="post__item-employment-type post__item-employment-type--label"
              />
            </span>
            <span class="columns post__item-org post__item-published">
              <img :src="hiringCompanySvgPath" class="post__item-icon" alt="" />
              <span />
            </span>
            <span class="columns post__item-location post__item-published">
              <img :src="locationSvgPath" class="post__item-icon" alt="" />
              <span />
            </span>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="job-ad job-ad--skeleton" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import JobMeta from '@/vue/components/fused/job_templates/job_meta.vue'
import JobBody from '@/vue/components/fused/job_templates/job_body.vue'
import JobExpiredNotice from '@/vue/components/fused/job_expired_notice.vue'
import JobOfflineNotice from '@/vue/components/fused/job_offline_notice.vue'

import calendarSvgPath from 'images/jobs/calendar.svg'
import finishFlagSvgPath from 'images/jobs/finish_flag.svg'
import hiringCompanySvgPath from 'images/jobs/hiring_company.svg'
import locationSvgPath from 'images/jobs/location.svg'
import workingHoursSvgPath from 'images/jobs/working_hours.svg'

export default {
  components: { JobBody, JobMeta, JobExpiredNotice, JobOfflineNotice },
  props: {
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    calendarSvgPath,
    finishFlagSvgPath,
    hiringCompanySvgPath,
    locationSvgPath,
    workingHoursSvgPath
  }),
  computed: {
    ...mapState(['job', 'jobLoadingId', 'resultsLoading']),
    ...mapGetters(['isJobExpired', 'jobTemplateStyle', 'isJobOffline'])
  },
  watch: {
    job: {
      handler(job) {
        if (!job && this.$refs.anchor) {
          // scroll skeleton into view if no job present
          this.$refs.anchor.scrollIntoView(true)
        }
      }
    }
  },
  mounted() {
    // normally we register the consent listeners in app.vue.
    // Since the preview only uses job_detail without mounting app.vue we need to register them here
    if (this.isPreview) {
      this.registerConsentListeners()
    }
  },
  methods: {
    ...mapActions(['registerConsentListeners'])
  }
}
</script>
